import { render, staticRenderFns } from "./BreakdownItem.vue?vue&type=template&id=5507627b&scoped=true&"
import script from "./BreakdownItem.vue?vue&type=script&lang=js&"
export * from "./BreakdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507627b",
  null
  
)

export default component.exports